export type EventCompletionStatusType = 'Saved' | 'Discarded' | 'Dismissed';
export const EVENT_COMPLETION_STATUS_SAVED = 'Saved';
export const EVENT_COMPLETION_STATUS_DISCARDED = 'Discarded';
export const EVENT_COMPLETION_STATUS_DISMISSED = 'Dismissed';

export type QuickComposeEntrySourceType =
    | 'NewButton'
    | 'Surface'
    | 'KeyboardShortcut'
    | 'Edit'
    | 'UndoFromNewButton'
    | 'UndoFromSurface'
    | 'UndoFromEdit'
    | 'Peek_Edit'
    | 'ContextMenu_Edit'
    | 'TimePanelNewButton'
    | 'TimePanelSurface'
    | 'BoardCalendarAsset'
    | 'GetStarted'
    | 'TimePanelAgenda'
    | 'SurfaceAgenda';

export const QUICK_COMPOSE_ENTRY_SOURCE_NEW_BUTTON = 'NewButton';
export const QUICK_COMPOSE_ENTRY_SOURCE_SURFACE = 'Surface';
export const QUICK_COMPOSE_ENTRY_SOURCE_EDIT = 'Edit';
export const QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_NEW_BUTTON = 'UndoFromNewButton';
export const QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_SURFACE = 'UndoFromSurface';
export const QUICK_COMPOSE_ENTRY_SOURCE_UNDO_FROM_EDIT = 'UndoFromEdit';
export const QUICK_COMPOSE_ENTRY_SOURCE_PEEK_EDIT = 'Peek_Edit';
export const QUICK_COMPOSE_ENTRY_SOURCE_CONTEXTMENU_EDIT = 'ContextMenu_Edit';
export const QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_NEW_BUTTON = 'TimePanelNewButton';
export const QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_SURFACE = 'TimePanelSurface';
export const QUICK_COMPOSE_ENTRY_SOURCE_BOARD_CALENDAR_ASSET = 'BoardCalendarAsset';
export const QUICK_COMPOSE_ENTRY_SOURCE_TIMEPANEL_AGENDA = 'TimePanelAgenda';
export const QUICK_COMPOSE_ENTRY_SOURCE_SURFACE_AGENDA = 'SurfaceAgenda';

export type FullComposeEntrySourceType =
    | 'QuickCompose'
    | 'Edit'
    | 'DragDrop'
    | 'PopOut'
    | 'Mail_SmartReplyWithMeeting'
    | 'Mail_ReplyByAllMeeting'
    | 'Deeplink_Edit'
    | 'Deeplink_Compose'
    | 'NewButton'
    | 'Surface'
    | 'KeyboardShortcut'
    | 'Peek_Edit'
    | 'CommandBar_Edit'
    | 'CommandBar_Copy'
    | 'ContextMenu_Edit'
    | 'Undo'
    | 'SearchPersonaCard'
    | 'ReviewPNT'
    | 'Mail_AcceptPNT'
    | 'DraftSurface'
    | 'DraftAgenda'
    | 'Mail_AddIns'
    | 'AddIns'
    | 'Compose_Header'
    | 'MailCalendarCard'
    | 'BlockOnSend'
    | 'TimePanel_DropOnPanelReplyWithMeeting'
    | 'TimePanel_DropOnAgendaReplyWithMeeting'
    | 'TimePanel_DropOnDayReplyWithMeeting'
    | 'TimePanelReviewPNT'
    | 'TimePanelEdit'
    | 'TimePanelContextMenuEdit'
    | 'TimePanelNewButton'
    | 'TimePanelSurface'
    | 'TimePanelPopout'
    | 'PeekReviewPNT'
    | 'FTDFEditSeriesLink'
    | 'FullComposeInfoBar'
    | 'MailCalendarCardScheduleNext'
    | 'ContextMenuDuplicate'
    | 'CommandBarDuplicate'
    | 'ComposeCommandBarDuplicate'
    | 'FindTime_VotingPage'
    | 'BoardCalendarAsset'
    | 'CollabSpaceWhatsNewCard'
    | 'CalendarWidget'
    | 'Mail_NewItems_EventButton'
    | 'SpacesCalendarAssetContextMenuDuplicate'
    | 'TimePanelContextMenuDuplicate'
    | 'CalendarAnswer'
    | 'FullCompose_SwitchAccount'
    | 'FullComposeReadRibbon_Edit';

export const FULL_COMPOSE_ENTRY_SOURCE_QUICK_COMPOSE = 'QuickCompose';
export const FULL_COMPOSE_ENTRY_SOURCE_DRAG_DROP = 'DragDrop';
export const FULL_COMPOSE_ENTRY_SOURCE_UNDO = 'Undo';
export const FULL_COMPOSE_ENTRY_SOURCE_BLOCK_ON_SEND = 'BlockOnSend';

export enum QuickComposeControl {
    GuidedCapture = 'GuidedCapture',
    Subject = 'Subject',
    AllDay = 'AllDay',
    DateTime = 'DateTime',
    Location = 'Location',
    Recurrence = 'Recurrence',
    Reminder = 'Reminder',
}

export enum QuickComposeToFullComposeEntryType {
    IconButton = 'IconButton',
    MoreOptionsButton = 'MoreOptionsButton',
}
